import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { NotificationsModule } from '../notifications/notifications.module';
import { ConnectivityCheckService } from './connectivity-check.service';

/**
 * Scheduled proof that the platform's external dependencies are reachable.
 *
 * Deliberately separate from DatabaseModule: that module's health checks are
 * about backups (WAL lag, quota, restore headroom) and only run where a backup
 * backend exists. This one answers a simpler and more urgent question — can we
 * reach the database and the object store at all — and must keep answering it
 * on hosts where no backup policy is enabled.
 */
@Module({
  imports: [NotificationsModule],
  providers: [PrismaService, ConnectivityCheckService],
  exports: [ConnectivityCheckService],
})
export class HealthModule {}
